import { useSearchParams } from 'react-router'

export type WalletTab = 'assets' | 'transactions'

export const useWalletTab = () => {
  const [params, setParams] = useSearchParams({ tab: 'assets' })
  const tab = params.get('tab') as WalletTab

  const handleTabChange = (tab: WalletTab) => {
    setParams({ tab: tab })
  }

  return [tab, handleTabChange] as const
}
